var VehicleSelectorV2 = function($container) {
    var _that = this;

    this.stepSelections = chatInitSelectSteps.slice(0);
    this.$dropdownContainer = $container.find('.vehicle-selector-stepwise-dropdowns');

    // Entries are {number: '', value: ''}
    this.steps = [];
    this.vehicleCompleteCallback = function() {};
    this.hasSelectedVehicleCallback = function() {};
    this.hasNoSelectedVehicleCallback = function() {};
    this.hasPartialVehicleSelected = function() {};

    this.init = function() {
        this.listen();

        if(this.stepSelections.length) {
            this.seedForm();
        } else {
            this.hasNoSelectedVehicleCallback();
        }
    };

    this.listen = function() {
        _that.$dropdownContainer.on('click', '.dropdown-item', function(e) {
            var $parent = $(this).parents('.dropdown');
            var $trigger = $parent.find('[data-toggle="dropdown"]');
            var value = $(this).attr('data-value');
            var label = $(this).html();
            var number = parseInt($trigger.attr('data-vstep'), 10);

            $trigger.find('.dropdown-label').html(label);
            $trigger.attr('data-value', value);
            $trigger.dropdown('toggle');

            // Find an existing array entry if it exists and update the value of it
            var exists = _that.steps.filter(function(step) {
               if(step.number === number) {
                   step.value = value;
                   return true;
               }
            });

            // If this step does not exist, add it to the current steps array.
            if(!exists.length) {
                _that.steps.push({number: number, value: value});
            } else {
                // Otherwise, we need to remove all steps after this one that exist and remove
                // the dom elements as well
                _that.steps = _that.steps.filter(function(step) {
                    if(step.number <= number) {
                        return true;
                    } else {
                        _that.$dropdownContainer.find('[data-vstep="'+step.number+'"]').parent().remove();
                    }
                });
            }

            _that.getNextStep();
        });
    };

    this.onVehicleSelected = function(fn) {
        this.vehicleCompleteCallback = fn;
        return this;
    };

    this.onHasSelectedVehicle = function(fn) {
        this.hasSelectedVehicleCallback = fn;
        return this;
    };

    this.onHasNoSelectedVehicle = function(fn) {
        this.hasNoSelectedVehicleCallback = fn;
        return this;
    };

    this.onHasPartialVehicleSelected = function(fn) {
        this.hasPartialVehicleSelected = fn;
        return this;
    };

    this.seedForm = function() {
        var makeSelection = this.stepSelections.shift();

        var $makeSelector = _that.$dropdownContainer.find('.dropdown:first');
        var label = $makeSelector.find('.dropdown-item[data-value="'+makeSelection+'"]').html();

        $makeSelector.find('.dropdown-label').html(label);
        $makeSelector.find('button').attr('data-value', makeSelection);

        this.steps.push({number: 1, label: label, value: makeSelection});
        _that.hasSelectedVehicleCallback();
        this.getNextStep();
    };

    this.getNextStep = function() {
        $container.find('.loading').removeClass('d-none');

        var data = {
            'initing': this.stepSelections.length > 0 ? 1 : 0,
            'currentPageURL': currentPageURL,
            'chatForm' : 'yes'
        };

        this.steps.forEach(function(step) {
            data['vstep_'+step.number] = step.value;
        });

        var _that = this;

        this.getStep(data)
            .done(function(response){
                if(response.newLocation || response.newLocation === '') {
                    $container.find('.loading').addClass('d-none');
                    _that.vehicleCompleteCallback(response);
                    return;
                }

                response.steps.forEach(function(step) {
                    var $template = _that.$dropdownContainer.find('.dropdown:first').clone();
                    $template.find('.dropdown-label').html(step.label);
                    $template.find('.dropdown-menu').html('');

                    step.options.forEach(function(option) {
                        var content = '<span class="dropdown-item" data-value="'+option.value+'">'+option.label+'</span>';
                        $template.find('.dropdown-menu').append(content);
                    });

                    var stepSelection = _that.stepSelections.shift();
                    var stepNumber = parseInt(step.stepNum, 10);

                    if(stepSelection) {
                        var label =  $template.find('.dropdown-item[data-value="'+stepSelection+'"]').html();
                        $template.find('.dropdown-label').html(label);
                        $template.find('[data-toggle="dropdown"]')
                            .attr('data-value', stepSelection)
                            .attr('data-vstep', step.stepNum);
                        _that.$dropdownContainer.append($template);
                        _that.steps.push({number: stepNumber, value: stepSelection});
                    } else {
                        if(step.options.length === 1) {
                            $template.find('.dropdown-label').html(step.options[0].label);
                            $template.find('[data-toggle="dropdown"]')
                                .attr('data-value', step.options[0].value)
                                .attr('data-vstep', step.stepNum);
                            _that.steps.push({number: stepNumber, value: step.options[0].value});
                        } else {
                            $template.find('.dropdown-label').html('Select ' + step.label);
                            $template.find('[data-toggle="dropdown"]')
                                .attr('data-value', '')
                                .attr('data-vstep', step.stepNum);
                            _that.steps.push({number: stepNumber, value: null});
                        }
                        _that.$dropdownContainer.append($template);
                    }
                });

                $container.find('.loading').addClass('d-none');

                if(data.initing !== 0) {
                    _that.getNextStep();
                } else {
                    _that.hasPartialVehicleSelected(response);
                }
            })
            .fail(function(thing) {
                console.log('fail');
            });
    };

    this.getStep = function(data) {
        var deferred = $.Deferred();

        $.ajax({
            method: 'GET',
            url: '/vehicleSelectorOptions',
            data: data
        })
            .done(function(result) {
                deferred.resolve(result);
            })
            .fail(function(failure) {
                deferred.reject(failure);
            });

        return deferred.promise();
    };

    this.getSelectedOptionsString = function() {
        var parts = [];
        _that.$dropdownContainer.find('.dropdown').each(function(i, el) {
            parts.push($(el).find('.dropdown-label').text());
        });
        return parts.join(' ');
    };
};
